export default __webpack_public_path__ + "static/media/betgalaxy_bg.d23e2221.png";